const colorHarmonyDefaultValue = '180';
const colorHarmonyDominanceDefaultValue = '50,50,50,50';

const colorHarmoniesList = [
    [Number(colorHarmonyDefaultValue)],
    [30, -30],
    [30, -30, 180],
    [120, 240],
    [150, 210],
    [60, 180, 240],
    [90, 180, 270],
];

const colorDominanceList = [
    [...colorHarmonyDominanceDefaultValue.split(',').map(Number)],
    [60, 30, 10, 10],
];

const colorHarmoniesDominanceStepBarList = [
    {
        type: 0,
        label: [[100]],
    },
    {
        type: 50,
        label: [
            [50, 50],
            [33, 33, 33],
            [25, 25, 25, 25],
        ],
    },
    {
        type: 60,
        label: [
            [65, 35],
            [60, 30, 10],
            [55, 35, 10, 10],
        ],
    },
];

export {
    colorHarmonyDefaultValue,
    colorHarmoniesList,
    colorDominanceList,
    colorHarmonyDominanceDefaultValue,
    colorHarmoniesDominanceStepBarList,
};
